import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';

import PageLoader from '@components/PageLoader';

import { useStyles } from './useStyles';

interface IMealCardSection {
  pages: any;
}

const MealCardSection = ({ pages }: IMealCardSection) => {
  const classes = useStyles();
  const router = useRouter();
  const { results } = pages || {};

  const SECOND_VARIATION = 'heroSectionWithTurmericBackground';

  const handleClickCard = (uid: string) => {
    router.push(`/${uid}`);
  };

  const getTag = (type: string) => {
    if (type === 'story') {
      return 'Lifestyle';
    } else if (type === 'fusion_recipe') {
      return 'Fusion Recipes';
    } else if (type === 'announcement') {
      return 'Announcements';
    } else {
      return 'Recipes';
    }
  };

  if (!results) {
    return <PageLoader />;
  }

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        {results?.map((item: any) => {
          const { primary, variation } = item?.data?.slices[0] || {};
          const { dish_name, by_whom, dish_image, description } = primary || {};
          return (
            <Box
              key={item.id}
              className={classes.itemContainer}
              onClick={() => handleClickCard(item?.uid)}
            >
              <Box
                className={classes.imgSection}
                bgcolor={
                  item?.type === 'story'
                    ? 'transparent'
                    : variation === SECOND_VARIATION
                    ? 'turmeric.main'
                    : 'cinnamon.main'
                }
                p={item?.type === 'story' ? '0px' : '25px'}
              >
                {dish_image?.url ? (
                  <Box
                    className={classes.imgWrapper}
                    sx={{
                      height: item?.type === 'story' ? '325px' : '275px',
                      width: item?.type === 'story' ? '325px' : '275px',
                    }}
                  >
                    <Image
                      src={dish_image?.url}
                      alt={dish_name}
                      objectFit="cover"
                      layout="fill"
                    />
                  </Box>
                ) : null}
              </Box>
              <Box maxWidth="312px" ml="13px" width="100%">
                <Box className={classes.textWrapper}>
                  <Typography variant="caption" align="left" color="cumin.main">
                    {by_whom}
                  </Typography>
                  <Typography
                    variant="caption"
                    align="center"
                    color="cumin.main"
                    sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                  >
                    {getTag(item?.type)}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  align="left"
                  color="cinnamon.main"
                  maxWidth="330px"
                >
                  {dish_name || ''}
                </Typography>
                <Typography
                  variant="caption"
                  align="justify"
                  color="cumin.main"
                  maxWidth="320px"
                >
                  {description ? description?.slice(0, 60) + ' ...' : ''}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default MealCardSection;
